/**
 * A simple way to check if a string already ends with the passed punctuation mark, else adds it to the end.
 * @param text
 * @param mark Punctuation mark to add
 *
 * @return {string}
 */
export const addPunctuationMark = (text = "", mark = "."): string => {
    const lastCharacter = text.substring(text.length - mark.length);
    if (lastCharacter !== mark) {
        return text + mark;
    }
    return text;
}